<template>
	<component
        :is="href ? 'a' : 'button'"
		type="button"
		:class="classes"
		:title="title"
        v-bind="href ? {href} : {disabled}"
		@click="$emit('click', $event)"
	>
		<slot></slot>
		<div dusk="btn-loader" v-if="loading">
			<svg
				role="img"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 512 512"
				class="w-20 h-20 block mr-8 ml-8 spin svg-inline&#45;&#45;fa fa-spinner fa-w-16 fa-2x"
			>
				<g class="fa-group">
					<path
						fill="currentColor"
						d="M108.92 355.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 416a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm208-208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm-60.92 147.08a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0-198.16a48 48 0 1 0-48-48 48 48 0 0 0 48 48z"
						class="fa-secondary"
					></path>
					<path
						fill="#e0dee3"
						d="M108.92 60.92a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM48 208a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM256 0a48 48 0 1 0 48 48 48 48 0 0 0-48-48z"
						class="fa-primary"
					></path>
				</g>
			</svg>
		</div>
	</component>
</template>

<script>
export default {
	props: {
		classes: {
			type: String,
			default: "button",
		},
		title: {
			type: String,
			default: "",
		},
		href: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
